import React from 'react';

/** Click-to-see-info for an add-on card on the subscription builder — image,
 *  price, calorie/macro breakdown, ingredients, and a quantity control.
 *
 *  Deliberately NOT the real MealModal: that component is built around
 *  ingredient substitution/recipient assignment for a cart line, none of which
 *  applies to a fixed-recipe add-on item here. Reuses the shared .sf-modal
 *  shell so it still looks consistent with the rest of the storefront. */
export default function AddonInfoModal({ addon, qty, onChangeQty, onClose }) {
  if (!addon) return null;

  return (
    <div className="sf-modal" role="dialog" aria-modal="true" aria-label={addon.name}>
      <button type="button" className="sf-modal__backdrop" onClick={onClose} aria-label="Close" />
      <div className="sf-modal__panel sf-addon-modal">
        {addon.imageUrl && (
          <div
            className="sf-addon-modal__image"
            style={{ backgroundImage: `url(${addon.imageUrl})` }}
          />
        )}
        <h2 className="sf-modal__title">{addon.name}</h2>
        <p className="sf-addon-modal__price">${Number(addon.price || 0).toFixed(2)}</p>

        {addon.calorieInfo?.calories > 0 && (
          <div className="sf-addon-modal__nutrition">
            <div>{Math.round(addon.calorieInfo.calories)} kcals</div>
            {addon.calorieInfo.carbsG != null && (
              <div>
                {Math.round(addon.calorieInfo.carbsG)}g carbs, {Math.round(addon.calorieInfo.proteinG)}g protein,{' '}
                {Math.round(addon.calorieInfo.fatG)}g fat, {Math.round(addon.calorieInfo.fiberG)}g fiber
              </div>
            )}
          </div>
        )}

        {addon.ingredients?.length > 0 && (
          <p className="sf-addon-modal__ingredients">
            <strong>Ingredients:</strong> {addon.ingredients.join(', ')}
          </p>
        )}

        <div className="sf-addon-modal__footer">
          <div className="sf-sub-stepper__controls">
            <button
              type="button"
              className="sf-sub-stepper__btn"
              aria-label={`Decrease ${addon.name}`}
              onClick={() => onChangeQty(Math.max(0, qty - 1))}
              disabled={qty <= 0}
            >
              −
            </button>
            <span className="sf-sub-stepper__qty">{qty}</span>
            <button
              type="button"
              className="sf-sub-stepper__btn"
              aria-label={`Increase ${addon.name}`}
              onClick={() => onChangeQty(qty + 1)}
            >
              +
            </button>
          </div>
          <button type="button" className="sf-btn-flow sf-btn-flow--secondary" onClick={onClose}>
            Done
          </button>
        </div>
      </div>
    </div>
  );
}
